var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commonHeader"},[_c('mt-header',{attrs:{"fixed":"","title":_vm.title}},[(_vm.showBack)?_c('mt-button',{attrs:{"slot":"left","icon":"back"},on:{"click":_vm.back},slot:"left"}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437dc760","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mtHeader.vue
// module id = null
// module chunks = 